import axiosInstance from "../../../services/axiosInstance";
import { STATUSES } from "./apiStatus";
import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";


export const pdfFile = createAsyncThunk(
  "pdf/fetch",
  async (uuid, { rejectWithValue }) => {
    try {
      const response = await axiosInstance.post(`/EsignServices/GetDocumentPath/${uuid}`);
      return response.data;
    } catch (error) {
      return rejectWithValue(error.message);
    }
  }
);

const pdfSlice = createSlice({
  name: "pdf",
  initialState: {
    pdfdata: {},
    status: STATUSES.IDLE,
    error: null,
  },
  reducers: {
    reset: (state) => {
      state.pdfdata = {};
      state.status = STATUSES.IDLE;
      state.error = null;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(pdfFile.pending, (state, action) => {
        state.status = STATUSES.LOADING;
      })
      .addCase(pdfFile.fulfilled, (state, action) => {
        state.pdfdata = action.payload;
        state.status = STATUSES.IDLE;
      })
      .addCase(pdfFile.rejected, (state, action) => {
        state.status = STATUSES.ERROR;
        state.error = action.payload;
      });
  },
});
export const { reset } = pdfSlice.actions;


export default pdfSlice.reducer;

